<!-- 代码已包含 CSS：使用 TailwindCSS , 安装 TailwindCSS 后方可看到布局样式效果 -->

<template>
  <div class="min-h-screen bg-gray-50 p-8">
    <!-- 顶部统计卡片 -->
    <div class="grid grid-cols-4 gap-6 mb-8">
      <div  :key="index" 
           class="bg-white rounded-lg p-6 shadow-sm">
        <div class="flex items-center justify-between mb-4">
          <h3 class="text-gray-500 text-sm">{{ statCards.title }}</h3>
          <i :class="['fas', statCards.icon, 'text-xl', statCards.iconColor]"></i>
        </div>
        <div class="flex items-end justify-between">
          <div>
            <p class="text-2xl font-semibold">{{ statCards.value }}</p>
            <div class="flex items-center mt-2">
              <i :class="[
                'fas',
                statCards.trend > 0 ? 'fa-arrow-up text-green-500' : 'fa-arrow-down text-red-500',
                'mr-1'
              ]"></i>
            </div>
          </div>
          <div class="w-24 h-12">
            <div ref="miniChart" class="w-full h-full"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- 筛选工具栏 -->
    <div class="bg-white rounded-lg p-4 mb-8 flex items-center justify-between">
      <div class="flex items-center space-x-4">
        <div class="relative">
          <button @click="toggleDatePicker" class="flex items-center px-4 py-2 border rounded-lg !rounded-button">
            <i class="fas fa-calendar-alt mr-2"></i>
            {{ dateRange }}
          </button>
        </div>
        <div class="relative">
          <button @click="toggleCategoryFilter" class="flex items-center px-4 py-2 border rounded-lg !rounded-button">
            <i class="fas fa-filter mr-2"></i>
            数据分类
          </button>
        </div>
      </div>
      <button 
    @click="exportOrderReport"
    class="px-4 py-2 bg-blue-600 text-white rounded-lg flex items-center hover:bg-blue-700 transition-colors"
    :disabled="isExporting"
  >
    <i class="fas fa-download mr-2"></i>
    {{ isExporting ? '导出中...' : '导出订单报表' }}
  </button>
    </div>

    <!-- 图表区域 -->
    <income-chart :chart-data="chartOption" />

    <div class="filter-area" style="margin-top: 50px;">
      <el-input
        v-model="searchQuery"
        placeholder="搜索订单号或买家ID"
        style="width: 300px"
        clearable
        @clear="handleSearchClear"
        @keyup.enter.native="fetchOrders"
      >
        <el-button slot="append" icon="el-icon-search" @click="fetchOrders"></el-button>
      </el-input>
      
      <el-date-picker
        v-model="dateRange"
        type="daterange"
        align="right"
        unlink-panels
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :picker-options="pickerOptions"
        @change="handleDateChange"
        style="margin-left: 20px;"
      >
      </el-date-picker>
    </div>
    
    <el-table
      :data="filteredOrders"
      border
      style="width: 100%; margin-top: 20px;"
      v-loading="loading"
      element-loading-text="数据加载中..."
    >
      <el-table-column prop="orderNumber" label="订单号" width="180"></el-table-column>
      <el-table-column prop="buyerId" label="买家ID" width="120"></el-table-column>
      <el-table-column prop="productPrice" label="产品价格" width="120">
        <template slot-scope="scope">
          {{ scope.row.productPrice | currency }}
        </template>
      </el-table-column>
      <el-table-column prop="orderAmount" label="订单金额" width="120">
        <template slot-scope="scope">
          {{ scope.row.orderAmount | currency }}
        </template>
      </el-table-column>
      <el-table-column prop="actualPayment" label="实际支付" width="120">
        <template slot-scope="scope">
          {{ scope.row.actualPayment | currency }}
        </template>
      </el-table-column>
      <el-table-column prop="orderProfit" label="订单利润" width="120">
        <template slot-scope="scope">
          <span :class="{'profit-positive': scope.row.orderProfit > 0, 'profit-negative': scope.row.orderProfit < 0}">
            {{ scope.row.orderProfit | currency }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" width="180" sortable>
        <template slot-scope="scope">
          {{ scope.row.createTime | formatDate }}
        </template>
      </el-table-column>
    </el-table>
    
    <div class="pagination-container">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalOrders"
      >
      </el-pagination>
    </div>

  </div>
</template>

<script>
import * as echarts from 'echarts';
import IncomeChart from '@/views/statistics/financial_statements/aa.vue';
import OrderApi from '@/api/order.js';
  import qs from 'qs';
export default {
  components: {
    IncomeChart
  },
  data() {
    return {
      dateRange: '2024-01-01 至 2024-03-31',
      searchQuery: '',
      currentPage: 1,
      pageSize: 10,
      statCards: [
        // {
        //   title: '净利润',
        //   value: '¥622,210',
        //   trend: -5.2,
        //   icon: 'fa-chart-line',
        //   iconColor: 'text-green-500',
        //   data: [10, 15, 20, 25, 30, 25, 35, 40, 45]
        // },
      ],
      tableHeaders: [
        { key: 'date', label: '日期' },
        { key: 'category', label: '类别' },
        { key: 'type', label: '类型' },
        { key: 'amount', label: '金额' },
        { key: 'note', label: '备注' }
      ],
      chartOption: {
        animation: false,
        tooltip: { trigger: 'axis' },
        legend: { data: ['收入'] },
        xAxis: { 
          type: 'category', 
          data: ['11月', '12月', '1月', '2月', '3月', '4月'] 
        },
        yAxis: { type: 'value' },
        series: [
          { 
            name: '收入', 
            type: 'bar', 
            data: [0, 0, 0, 0, 0, 2298], 
            itemStyle: { color: '#60A5FA' } 
          },
          { 
            name: '利润', 
            type: 'bar', 
            data: [], 
            itemStyle: { color: '#34D399' } 
          }
        ]
      },
      tableData: [
        { date: '2024-03-28', category: '产品销售', type: '收入', amount: '286,500', note: '季度大促销售' },
        { date: '2024-03-27', category: '原材料采购', type: '支出', amount: '125,800', note: '原料库存补充' },
        { date: '2024-03-26', category: '技术服务', type: '收入', amount: '95,000', note: '系统维护服务费' },
        { date: '2024-03-25', category: '人力资源', type: '支出', amount: '458,000', note: '员工薪资发放' },
        { date: '2024-03-24', category: '广告投放', type: '支出', amount: '76,500', note: '线上推广费用' },
        { date: '2024-03-23', category: '产品销售', type: '收入', amount: '195,800', note: '新产品首发' },
        { date: '2024-03-22', category: '办公用品', type: '支出', amount: '12,600', note: '季度办公用品采购' },
        { date: '2024-03-21', category: '咨询服务', type: '收入', amount: '150,000', note: '企业战略咨询' },
        { date: '2024-03-20', category: '设备维护', type: '支出', amount: '35,800', note: '生产线维护' },
        { date: '2024-03-19', category: '产品销售', type: '收入', amount: '326,500', note: '渠道代理销售' }
      ],
      isExporting: false,
      exportFields: [
        { label: '订单ID', value: 'order_id' },
        { label: '订单编号', value: 'order_no' },
        { label: '用户ID', value: 'user_id' },
        { label: '总金额', value: 'total_price' },
        { label: '实付金额', value: 'pay_price' },
        { label: '支付状态', value: 'pay_status' },
        { label: '支付时间', value: 'pay_time' },
        { label: '订单状态', value: 'order_status' },
        { label: '配送方式', value: 'delivery_type' },
        { label: '物流单号', value: 'express_no' },
        { label: '创建时间', value: 'create_time' },
      ],
      orders: [],
      filteredOrders: [],
      loading: false,
      searchQuery: '',
      dateRange: [],
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      currentPage: 1,
      pageSize: 10,
      totalOrders: 0
    };
  },
  filters: {
    currency(value) {
      if (value === undefined || value === null) return '¥0.00';
      return '¥' + parseFloat(value).toFixed(2);
    },
    formatDate(value) {
      if (!value) return '';
      return new Date(value).toLocaleString();
    }
  },
  created() {
    this.fetchIncomeData();
    this.fetchOrders();
  },
  computed: {
    totalItems() {
      return this.tableData.length;
    },
    totalPages() {
      return Math.ceil(this.totalItems / this.pageSize);
    },
    filteredTableData() {
      const start = (this.currentPage - 1) * this.pageSize;
      const filtered = this.tableData.filter(item => 
        Object.values(item).some(val => 
          val.toString().toLowerCase().includes(this.searchQuery.toLowerCase())
        )
      );
      return filtered.slice(start, start + this.pageSize);
    }
  },
  methods: {

    async exportOrderReport() {
  this.isExporting = true;
  
  try {
    let baseUrl = window.location.protocol + '//' + window.location.host;
    // 确保传递 dataType 参数
    const params = {
      ...this.searchForm,
      dataType: 'completed' // 或其他需要的类型，如 'all', 'paid' 等
    };
    
    window.location.href = baseUrl + '/index.php/shop/order.operate/exportCWOrder?' + qs.stringify(params);
  } catch (error) {
    console.error('导出失败:', error);
    this.$message.error('导出失败: ' + error.message);
  } finally {
    this.isExporting = false;
  }
},
    initCharts() {
      this.initBarChart();
      this.initPieChart();
      // this.initMiniCharts();
    },
    statCardsdata(){
      OrderApi.statCards()
      .then((res)=>{
        console.log(res);
        this.statCards = res.data
      })
    },
    fetchOrders() {
      this.loading = true;
      
      OrderApi.completedOrders({
        params: {
          search: this.searchQuery,
          startDate: this.dateRange[0] ? this.formatDate(this.dateRange[0]) : '',
          endDate: this.dateRange[1] ? this.formatDate(this.dateRange[1]) : '',
          page: this.currentPage,
          pageSize: this.pageSize
        }
      })
      .then(response => {
        if (response.code === 1) {
          this.filteredOrders = response.data.list;
          this.totalOrders = response.data.total;
        } else {
          this.$message.error(response.data.message || '获取订单数据失败');
        }
      })
      .catch(error => {
        console.error('Error fetching orders:', error);
        this.$message.error('获取订单数据时出错');
      })
      .finally(() => {
        this.loading = false;
      });
    },

    formatDate(date) {
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    handleSearchClear() {
      this.searchQuery = '';
      this.fetchOrders();
    },
    handleDateChange(val) {
      this.dateRange = val;
      this.fetchOrders();
    },
    handleViewDetail(row) {
      // 查看订单详情逻辑
      this.$router.push(`/order/detail/${row.orderNumber}`);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.fetchOrders();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchOrders();
    },
    async fetchIncomeData() {
      try {
       await OrderApi.incomeStatistics().then((res)=>{
        this.chartOption = res.data.chartOption;
       });
      } catch (error) {
        this.$message.error('请求图表数据失败');
        console.error('获取图表数据错误:', error);
      }
    },
    initBarChart() {
      const chart = echarts.init(this.$refs.barChart);
      let option = {};
      OrderApi.incomeChart().then((res)=>{
        console.log(res);
        option = res.data  
      })
      chart.setOption(option);
    },
    initPieChart() {
      const chart = echarts.init(this.$refs.pieChart);
      const option = {
        animation: false,
        tooltip: {
          trigger: 'item'
        },
        legend: {
          orient: 'vertical',
          left: 'left'
        },
        series: [
          {
            type: 'pie',
            radius: '50%',
            data: [
              { value: 1048, name: '产品销售' },
              { value: 735, name: '技术服务' },
              { value: 580, name: '咨询服务' },
              { value: 484, name: '其他收入' }
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      };
      chart.setOption(option);
    },
    // initMiniCharts() {
    //   this.statCards.forEach((card, index) => {
    //     const chartDom = this.$refs.miniChart[index];
    //     const chart = echarts.init(chartDom);
    //     const option = {
    //       animation: false,
    //       grid: {
    //         left: 0,
    //         right: 0,
    //         top: 0,
    //         bottom: 0
    //       },
    //       xAxis: {
    //         type: 'category',
    //         show: false
    //       },
    //       yAxis: {
    //         type: 'value',
    //         show: false
    //       },
    //       series: [{
    //         data: card.data,
    //         type: 'line',
    //         showSymbol: false,
    //         lineStyle: {
    //           color: this.getMiniChartColor(index)
    //         },
    //         areaStyle: {
    //           color: this.getMiniChartColor(index),
    //           opacity: 0.2
    //         }
    //       }]
    //     };
    //     chart.setOption(option);
    //   });
    // },
    getMiniChartColor(index) {
      const colors = ['#60A5FA', '#F87171', '#34D399', '#A78BFA'];
      return colors[index % colors.length];
    },
    toggleDatePicker() {
      // 日期选择器切换逻辑
    },
    toggleCategoryFilter() {
      // 分类筛选切换逻辑
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    }
  },
  mounted() {
    this.statCardsdata();
    window.addEventListener('resize', () => {
      this.initCharts();
    });
  },
  beforeDestroy() {
    window.removeEventListener('resize', () => {
      this.initCharts();
    });
  }
};
</script>

<style scoped>
.chart-container {
  position: relative;
}

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

table th {
  white-space: nowrap;
}

.order-container {
  padding: 20px;
}

.filter-area {
  margin-bottom: 20px;
  display: flex;
  align-items: center;
}

.pagination-container {
  margin-top: 20px;
  text-align: right;
}

.profit-positive {
  color: #67C23A;
}

.profit-negative {
  color: #F56C6C;
}

table td {
  white-space: nowrap;
}
</style>




// WEBPACK FOOTER //
// src/views/statistics/financial_statements/index.vue